export enum Currency {
	ETH = 'ETH',
	USD = 'USD',
	GLI = 'GLI'
}